module.exports = "<div class=\"search-bar\" layout=\"row\">\n  <md-input-container class=\"search-input-container\">\n    <label>{{ placeholderText }}</label>\n    <input type=\"text\" ng-model=\"searchFilter\" class=\"search-input\" />\n  </md-input-container>\n  <div>\n    <md-button type=\"md-icon-button\" ng-click=\"searchFilter=''\" flex>\n      <i class=\"fa fa-times\"></i>\n    </md-button>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./common/directives/search-bar/search-bar.dir.html
// module id = 1123
// module chunks = 0